export default {
  currency: {
    style: 'currency', currency: 'USD'
  },
  app: {
    signin: 'Log in',
    signup: 'Sign up',
    or: 'or',
    save: 'Save',
    yes: 'Yes',
    no: 'No',
    clickHere: 'Click here',
    back: 'Go back',
    info: {
      noResults: 'Your search did not return any results',
      noMoreResults: 'There are no more results'
    },
    delete: 'Delete',
    loading: 'Loading',
    discover: 'Discover',
    shop: 'Shop',
    '360': '360',
    latestNews: 'Latest News',
    featuredPlaylist: {
      title: 'Featured Playlist',
      createdBy: 'Created by'
    },
    recommended: 'Recommended by BeatHey',
    leaveConfirmation: 'Are you sure you want to leave the site? The information entered will be lost',
    notAllowed: 'Your account is not allowed to perform this action.',
    notShowAgain: 'Accept'
  },

  form: {
    message: 'Message',
    send: 'Submit'
  },

  provider: {
    directLink: 'Create home screen access'
  },

  discover: {
    carousels: {
      artists: 'ARTISTS',
      tracks: 'THE LAST',
      playlists: 'PLAYLISTS',
      recommendedPlaylists: 'RECOMMENDED PLAYLISTS'
    }
  },

  error: {
    emailRequired: 'Email is required',
    emailInvalid: 'Email is invalid',
    emailRepeated: 'Email already exists',
    confirmEmailRequired: 'Email confirmation is required',
    confirmEmailInvalid: 'The two emails do not match',
    valueRequired: 'Amount required',
    valueInvalid: 'Amount must be a number',
    valueMinPrice: 'Amount must be greater or equal than: ',
    voucherInvalid: 'Non-existent Voucher, try something else',
    voucherInactive: 'Voucher is no longer active',
    voucherFulled: 'Voucher exhausted',
    shortVoucher: 'Voucher must have more than 10 characters',
    longVoucher: 'Voucher must have less than 10 characters',
    trackNameRequired: 'Track name is required',
    iswcErrorCode: 'ISWC code must respect the format T-xxxxxxxxx-x',
    genreRequired: 'Track genre is required',
    usernameRequired: 'Username is required',
    usernameRepeated: 'Username already exists',
    idRequired: 'ID is required',
    shortId: 'ID too short',
    phoneInvalid: 'Phone is invalid',
    addressRequired: 'Address is required',
    birthdateRequired: 'Birthdate is required',
    confirmPasswordInvalid: 'Passwords do not match',
    passwordRequired: 'Password is required',
    nameRequired: 'Name is required',
    messageRequired: 'Message is required',
    messageMaxLength: 'The message is too long. Maximum number of characters is 2048',
    playlistRequired: 'You must select a playlist',
    playlistNameRequired: 'Playlist name is required',
    trackUpload: 'An error occurred while saving the track',
    pictureRequired: 'Picture is required',
    minPriceRequired: 'This field is required',
    minPriceValue: 'The amount cant be less than 1 USD',
    albumNameRequired: 'You must enter a name for the album',
    trackFileRequired: 'You must Upload a Track',
    albumUpload: 'Failed to save album',
    store: {
      network: 'Network error',
      userValidation: 'An error occurred while validating the user',
      paymentLink: 'There was an error getting the payment link',
      myFavorites: 'An error occurred while loading my favorites',
      myTracks: 'An error occurred while loading my tracks',
      myPlaylists: 'An error occurred while loading my playlists',
      voteValidation: 'An error occurred while verifying your votes',
      data: 'An error occurred while loading the data',
      artists: 'An error occurred while loading artists',
      playlists: 'An error occurred while loading playlists',
      tracks: 'An error occurred while loading tracks',
      voteQuote: 'You have already voted 3 artists! In the next month you will have 3 new votes to continue voting',
      SameArtistAndUser: 'You can\'t vote yourself',
      vote: 'An error occurred while voting an artist',
      vinylContest: 'An error occurred while loading vinyl contest',
      contact: 'An error occurred while sending the message',
      addToPlaylist: 'An error occurred while adding a track to the playlist',
      newPlaylist: 'There was an error creating the playlist',
      deletePlaylist: 'There was an error deleting the playlist',
      updatePlaylist: 'There was an error editing the playlist',
      deleteFromPlaylist: 'There was an error deleting track from the playlist',
      deleteTrack: 'There was an error deleting track',
      noDataPosted: 'Error: missing data',
      authenticationFailed: 'The email or password is incorrect',
      login: 'An error occurred while loging in',
      playlist: 'An error occurred while loading the playlist',
      playlistPrivate: 'Error: private playlist',
      playlistNotFound: 'Error: playlist not found',
      featuredPlaylist: 'An error occured while loading featured playlist',
      artistNotFound: 'Error: artist not found',
      notSaved: 'Error: changes not saved',
      editArtist: 'Error while updating artist data',
      notValidToken: 'Authentication error',
      track: 'An error occurred while loading track',
      likePlaylist: 'An error occurred while liking the playlist'
    }
  },

  users: {
    login: 'Log in',
    username: 'Username',
    name: 'Name | Names',
    surnames: 'Surnames',
    id: 'ID',
    email: 'Email',
    emailConfirmation: 'Confirm email',
    address: 'Address',
    password: 'Password',
    phone: 'Phone',
    birthdate: 'Birthdate',
    day: 'Day',
    month: 'Month',
    year: 'Year',
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October',
      'November', 'December'],
    code: 'Code',
    voucher: 'Enter the discount code',
    generateReferralCode: 'Generate Referral Code',
    choseUserType: 'Choose your profile',
    textUserType: 'This option can be changed in "Mi Profile"',
    userType: {
      musicFan: 'Fan',
      producer: 'Artist',
      free: 'Listener',
      flowArtist: {
        artisticName: 'Artistic name',
        text: 'You can change all your personal and artistic information in "My Profile"'
      }
    },
    registration: {
      shareData: 'Share my registration data with BEATHEY content providers for marketing purposes.',
      accept: 'By clicking on REGISTER, you accept',
      comma: ', the',
      andThe: 'and the',
      register: 'Register',
      alreadyHaveAnAccount: 'Already have an account?'
    },
    accept: {
      newsLetter: 'I agree to receive Newsletter',
      shareInfo: 'I agree to share contact information with Artists'
    },
    bio: 'Bio',
    bioDescription: 'Write something about yourself that represents you',
    country: 'Country',
    city: 'City',
    forgetPassword: {
      question: 'Forget your password?',
      success: 'A new password was sent to the email',
      button: 'Submit'
    },
    rememberPassword: 'Did you remember your password?',
    changePassword: 'Change password',
    passwordConfirmation: 'Confirm password',
    hasNotFavorites: 'You haven\'t added a track to your favorites',
    editSuccess: 'The information was updated correctly',
    loginToUnauthorizedUser: 'To continue listening to music, we invite you to register',
    cancelLoginToUnauthorizedUser: 'Cancel',
    subscription: {
      title: 'Subscribe!',
      info1: 'Vinyl as a gift with the best 4 artists of each Vinyl Contest (Only for Argentina)',
      info2: 'Receive BeatHey Mag as a gift (Only for Argentina)',
      info3: 'If you are an artist, you have the possibility to publish your music and be voted on in the Vinyl Contest',
      info4: 'If you are an artist, 100% of the music sales collection is yours.',
      info5: 'If you are an artist, you can be selected to play at BeatHey events',
      info6: 'Payment methods',
      infoEmailNeeded1: 'For internal MercadoPago regulations, we need the e-mail address associated to the wallet (MercadoPago) with which we will perform the transaction',
      infoEmailNeeded2: 'This information will not be stored by BeatHey and is for the exclusive use of this operation.',
      valueTitle: 'Be part of the community by',
      currency: 'U$D',
      value: '3',
      free: 'Free!!',
      button: 'Subscribe',
      cancel: 'Cancel',
      disaffiliate: 'Disaffiliate',
      confirm: 'Confirm',
      reject: 'Reject',
      cancelTitle: 'Thank you for choosing us!',
      cancelMessage: 'Are you sure to cancel your BeatHey subscription?',
      cancelAccountMessage: 'Are you sure to cancel your BeatHey account?',
      cancelAccount: 'Cancel your BeatHey account.',
      cancelAccountSuccess: 'Your BeatHey account has been successfully deleted.',
      cancelAccountError: 'There was a problen deleting your account.',
      cancelSubscription: 'Disaffiliate your recurring subscription to BeatHey.',
      canceledMPsubSuccess: 'Your recurring subscription through Mercado Pago has been successfully Canceled',
      canceledMPsubError: 'Your recurring subscription through Mercado Pago has already been Canceled',
      voucherCodeMsg: 'Enter your Benefits code',
      referredCodeMsg: 'Enter your referral code',
      sendEmailNeeded: 'To Process'
    },
    payment: {
      message: 'Choose one payment method'
    },
    userMenu: {
      myProfile: 'Profile',
      myTracks: 'My Tracks',
      myPlaylists: 'My Playlists',
      myFavorites: 'My Favorites',
      myShopping: 'My Purchases',
      myAccount: 'Mi Account',
      help: 'Help',
      terms: 'Terms and Conditions',
      logout: 'Logout'
    },
    followArtist: 'Now you follow',
    unfollowArtist: 'You stopped following',
    follow: 'Follow',
    following: 'Following',
    copyCodeSucces: 'The code was copied correctly',
    copyLinkSucces: 'The link was copied correctly',
    copyError: 'An error occurred while copying'
  },

  artists: {
    seeAll: 'See all',
    artists: 'Artists',
    artist: 'Artist | Artists',
    search: {
      placeholder: 'Search by name...',
      noMoreResults: 'There are no more results'
    },
    info: 'Artist information',
    name: 'Name',
    phrase: 'Descent',
    text: 'Info',
    hasNotTracks: 'Artist does not have any track',
    hasNotPlaylists: 'Artists does not have any playlist',
    hasNotInfo: 'Artist does not have information',
    section: {
      info: 'Info',
      contact: 'Contact'
    },
    contact: {
      messagePlaceholder: 'Write your message here',
      success: 'The masseage was sent correctly'
    }
  },

  albums: {
    uploadAlbum: 'Upload Album',
    newAlbum: {
      warningMessage: 'Fill in the album details to access track loading',
      namePlaceholder: 'Album name',
      uploaded: 'The album was created successfully',
      selectFiles: 'Select files',
      uploadButton: 'Upload Album',
      tagsPlaceholder: 'Describe the members who participated in the development of the work. Ex: PRODUCER, MIXING AND MASTERING, COVER ART, etc.'
    }
  },

  tracks: {
    seeAll: 'See all',
    uploadTrack: 'Upload Track',
    track: 'No tracks | track | tracks',
    title: 'Title',
    artist: 'Artist',
    genre: 'Genre',
    genres: {
      all: 'All'
    },
    minPrice: 'Minimum price in U$D',
    release: 'Date',
    actions: {
      like: 'Like',
      addToQueue: 'Add to queue',
      buy: 'Buy',
      share: 'Share',
      addToPlaylist: 'Add to playlist',
      deleteFromPlaylist: 'Delete from playlist',
      edit: 'Edit',
      credits: 'Credits'
    },
    buyTrack: {
      title: 'Help to ',
      line1: 'By downloading the track you help the artist to keep working on their music.',
      line2: 'You decide how much you value their music.',
      downloadMessage: 'You will find the track\'s download link in the "My Purchases" Profile section.',
      valueLabel: 'Amount',
      button: 'Purchase'
    },
    newTrack: {
      button: 'Load Content',
      newRelease: 'Agregar a la lista de NEW RELEASE',
      dropSelectTrack: 'Drop or select the file',
      selectFile: 'Select file',
      dropMessage: 'Drop file to upload',
      important: 'Important: ',
      info: 'By sharing, you confirm that your sounds comply with our terms of use and do not infringe the rights of any other person. In case of doubt, please check our pages and FAQ copyright information before uploading.',
      question1: 'Problems uploading files?',
      answer1: 'Please see our troubleshooting tips.',
      question2: 'What types of files can I upload?',
      answer2: 'You can load MP3s. The maximum file size is 50MB.',
      extensionMessage: 'The file must be mp3',
      leaveConfirmation: 'Are you sure you want to leave the site? Track is not saved',
      notProducer: 'To upload tracks you must subscribe as a DJ/Producer!',
      uploaded: 'The track was uploaded correctly',
      imageError: 'The selected image exceeds the expected dimensions, it must be less than 4024 x 3768 pixels',
      imageType: 'The file must be an image (jpg,jpeg,png)'
    },
    editTrack: {
      title: 'Share your music',
      selectPicture: 'Select track image',
      completed: 'Full load',
      namePlaceholder: 'Track name',
      tagsPlaceholder: 'Describe in words the style of your track',
      creditsPlaceholder: 'Add credits',
      recommendedPlaceHolder: 'Tell us what your musical genre is! Help us expand the BeatHey family.',
      uploaded: 'The track was uploaded correctly',
      iswcCode: 'Code ISWC Ej: T-xxxxxxxxx-x (optional)',
      saveChanges: 'Save Changes',
      listUploaded: 'The list was updated successfully'
    },
    deleteTrack: {
      title: 'Delete track',
      success: 'The track was deleted',
      confirm: 'Are you sure you want to delete the track?'
    },
    shareTrack: {
      title: 'Share track',
      copy: 'Copy',
      success: 'The link was copied correctly',
      error: 'An error occurred while copying the link'
    },
    licenses: {
      features: 'Licenses features',
      selected: 'Chosen license',
      questions: {
        1: {
          title: 'Do you want to allow adaptations of your work to be shared?',
          options: {
            1: 'Yes',
            2: 'No',
            3: 'Yes, as long as it is shared in the same way'
          }
        },
        2: {
          title: 'Do you want to allow commercial uses of your work?',
          options: {
            1: 'Sí',
            2: 'No'
          }
        }
      }
    },
    headers: {
      title: 'Title',
      artist: 'Artist',
      genre: 'Genre',
      released: 'Released',
      duration: 'Duration',
      date: 'Bought'
    }
  },

  playlists: {
    seeAll: 'See all',
    playlist: 'Playlist | Playlists',
    type: {
      public: 'Public',
      private: 'Private'
    },
    isPrivate: 'This playlist is private',
    addToPlaylist: {
      title: 'Add to playlist',
      select: 'Select a playlist',
      add: 'Add',
      success: 'The track was added to playlist correctly',
      trackAlreadyExist: 'The track already exists in this playlist'
    },
    newPlaylist: {
      button: 'New playlist',
      title: 'New playlist',
      imageError: 'An error occurred while uploading the playlist image',
      playlistName: 'Playlist title',
      saveAndAdd: 'Save and add',
      success: 'The playlist was created correctly'
    },
    delete: {
      confirm: 'Are you sure you want to delete the playlist?',
      success: 'The playlist was deleted correctly',
      title: 'Delete Playlist'
    },
    edit: {
      title: 'Edit playlist',
      button: 'Edit',
      success: 'The playlist was updated correctly'
    },
    deleteTrackFromPlaylist: {
      title: 'Delete track from playlist',
      success: 'The track was deleted from playlist correctly',
      confirm: 'Are you sure you want to delete the track from the playlist?'
    },
    sharePlaylist: 'Share playlist',
    like: {
      button: 'like'
    }
  },

  vinylContest: {
    noArtist: 'No artists have been voted yet',
    vote: 'Vote',
    success: 'Your vote was registered!',
    link: 'Go to Contest',
    title: 'Contest',
    closeIn: 'Close in:',
    day: 'day | days',
    hour: 'hour | hours',
    minute: 'minutes | minute | minutes'
  },

  payment: {
    mpConnect: {
      info: 'Connect to Mercado Pago to receive 100% of the sales of your tracks, without intermediaries, directly to your personal account.',
      title: 'Collect the sale of your tracks through Mercado Pago!',
      connectedAs: 'Connected as',
      disconnectInfo: 'To disconnect your account enter to ',
      nickname_title_help: 'This information it\'s visible for te buyer in the checkout process. We recommend to choose a related name to the artist.'
    },
    connect: 'Connect',
    paypal: {
      subscriptionSuccess: 'Your subscription was generated successfully'
    }
  },

  help: {
    title: 'How can we help?',
    contactInformation: 'Contact information',
    whatsapp: '+54 911 5574 0051',
    email: 'contacto@beathey.com',
    contactForm: {
      title: 'Send us your question',
      success: 'The message was sent correctly'
    },
    unsubscribe: 'Remember, to unsubscribe with ',
    send: 'send ',
    to: 'to ',
    faqs: 'FAQs'
  },

  uploadPicture: {
    selectPicture: 'Select image'
  },

  footer: {
    terms: 'Terms and conditions',
    termsOfUse: 'Terms and conditions of use',
    intellectuallyProp: 'Intellectual property policy',
    privacyPolicy: 'Privacy and cookie policy',
    help: 'Help',
    contact: 'Contact',
    company: 'Company',
    language: {
      title: 'Language',
      spanish: 'Español',
      english: 'English',
      portuguese: 'Português'
    }
  },
  ads: {
    advertisingSpace: 'Advertising space'
  },
  landing: {
    plans: 'Plans',
    music: 'Music',
    title: 'without intermediaries',
    subtitle: 'Closer to your audience, closer to your artist',
    leyend: 'START CHANGING LIFES',
    button1: 'Listening',
    button2: 'Creating',
    join: 'Join!',
    joinText: 'Get to know our',
    description: {
      t1: 'Income',
      t2: 'is 100%',
      t3: 'for the artist'
    },
    oyendo: {
      title: 'Not Just Listening',
      carousel: {
        text1: 'You support, help and build community by Listening, Sharing, Buying and Voting.',
        text2: 'We are a community of independent artists, and your support goes directly to each of us, without intermediaries.',
        text3: 'We are developing a new concept in the music industry and we want you to be part of it.'
      },
      button: 'Plans'
    },
    creando: {
      title: 'Incubating talent',
      carousel: {
        text1: 'Your effort is monetized, the more they listen to you, the more they vote for you, the more your music sells, the more exposure you will get.',
        text2: 'You are the owner of your rights, sell your music without intermediaries, get votes from the community in the quarterly contest and be part of our magazine.',
        text3: 'We are a community of independent artists, creating a new concept in the music industry where we are the protagonists. Experience it with us!'
      },
      button: 'Plans'
    },
    planes: {
      title: 'Your subscription generates change.',
      leyend: 'The revenue from subscriptions is distributed to the artists under the concept of "pay-per-stream". In this way, your subscription is directly impacting the artists, generating more opportunities for them.',
      free: {
        text1: 'Listen to Music',
        text2: 'BeatHey Inherent Advertising',
        text3: 'Buy Music'
      },
      fan: {
        text1: 'Bookmark',
        text2: 'Vote in Contest',
        text3: 'Listen without Advertising',
        text4: 'Digital Releases of contest winners free of charge',
        text5: 'BeatHey Mag magazine, physical and/or digital, free of charge',
        text6: 'Discounts of up to 60% on BeatHey festival tickets'
      },
      artist: {
        header: 'All the benefits of the Fan and more...',
        text1: 'Upload music and monetize it',
        text2: 'Receive double income per playback (pay per stream)',
        text3: 'Possibility of presentations at BeatHey festivals under endorsement of the curatorial team.'
      }
    }
  },
  dashboard: {
    title: 'Dashboard',
    atention: 'Atention...',
    apply: 'Apply',
    upload: 'Songs Uploaded',
    daysWithoutUpload: 'Days without Uploading',
    avg: 'Average songs Uploaded',
    likes: 'Likes',
    followers: 'Followers',
    reproductionsRanking: 'Reporductions Ranking',
    songRanking: 'Reproductions Detail',
    trackName: 'Track Name',
    duration: 'Duration',
    warning: 'This module allows you to access information about what happens with your works and thus be able to make decisions. Subscribe through the "Upload Content" button to access 100% of the available information.',
    tooltipAdmin: 'You are an administrator.',
    tooltipArtist: 'You are an artist.',
    tooltipSubscribed: 'You are subscribed.',
    tableName: 'Name',
    tableArtist: 'Artist',
    tableRepro: 'Reproductions',
    tableLikes: 'Likes'
  },
  localContent: {
    title: 'LIVE',
    category: 'Category'
  }
}



// WEBPACK FOOTER //
// ./src/translator/en.js